<script setup lang="ts">
import Restart from '@material-symbols/svg-400/rounded/replay.svg'
import ResultScale from './ResultScale.vue'
import { state } from '../state'
import { ref } from 'vue';

const isDev = import.meta.env.DEV

function onClick() {
  window.location.reload()
}

const resultValue = ref(parseFloat(state.result!.hba1c));

</script>
<template>
  <div class="px-2 py-8 text-center dark:text-gray-300">
    <p class="text-xl">Your test result</p>
    <input v-if="isDev" type="range" min="0" max="13" step="0.1" v-model="resultValue" />
    <div class="flex items-center justify-center flex-col mt-4">
      <div class="shadow-md border rounded-md w-full px-2 py-8">
        <ResultScale :value="resultValue" />
      </div>
      <div
        class="flex items-center rounded-md my-4 px-8 py-4 text-xl font-bold border shadow-md divide-x-2 space-x-4"
      >
        <span class="w-1/5">{{ resultValue }}%</span>
        <span class="pl-4 text-base text-left w-4/5">
          <p v-if="resultValue < 5.7">
            Your HbA1c result indicates you are not in a diabetes stage. Please do the test again in 
            6 months to track your diabetes status.
          </p>
          <p v-if="resultValue >= 5.7 && resultValue <= 6.5">
            Your HbA1c result indicates you are already in a pre-diabetes stage. Please consult 
            a doctor as soon as possible, and do the test again in 3 months to track your diabetes status.
          </p>
          <p v-if="resultValue > 6.5">
            Your HbA1c result indicates you are already in a diabetes stage. Please consult a doctor as
            soon as possible, and do the test again in 3 months to track your diabetes status.
          </p>
        </span>
      </div>
    </div>
    <div class="flex justify-center my-4 text-sm">
      <button @click="onClick" class="btn-next py-2 px-4">
        Check another barcode
        <Restart class="w-4 h-4 ml-2" />
      </button>
    </div>
  </div>
</template>
